import { render, staticRenderFns } from "./WarehouseCardProduct.vue?vue&type=template&id=485adc08&"
import script from "./WarehouseCardProduct.vue?vue&type=script&lang=js&"
export * from "./WarehouseCardProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports